import { FC } from "react";
import { Entity } from "../../common/types/entity";
import { Tag } from "../general/Tag/Tag";
import { EntityIcon } from "../entity/EntityIcon";
import styles from "./ActionEntityTag.module.scss";

interface ActionEntityTagProps {
    entity: Entity;
}

export const ActionEntityTag: FC<ActionEntityTagProps> = ({ entity }) => (
    <Tag variant="light" outline className={styles.tag}>
        <EntityIcon entity={entity} size="xxs" />
        {entity.name}
    </Tag>
);
